import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BUNDLES_EP,
  PROPOSALS_EP,
  RATES_EP,
  VIN_EP
} from '@app/shared/constants/globalConstants';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { DebugLogService } from '../services/debug-log.service';

@Injectable()
export class DebugLogHttpInterceptor implements HttpInterceptor {
  constructor(private readonly debugLogService: DebugLogService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const enabled = this.debugLogService.isEnabled();
    const shouldLog = enabled && this.shouldLogUrl(req.url);
    const appName = sessionStorage.getItem('appName');

    if (shouldLog) {
      try {
        this.debugLogService.info('HTTP REQ', {
          method: req.method,
          url: req.url,
          params: req.params?.keys()?.length ? req.params.toString() : null,
          body: req.body ?? null
        });
        this.debugLogService.flush({ appName, mode: 'HTTP REQUEST' });
      } catch {}
    }

    return next.handle(req).pipe(
      tap(event => {
        if (!shouldLog) return;

        if (event instanceof HttpResponse) {
          try {
            this.debugLogService.info('HTTP RES', {
              url: req.url,
              status: event.status,
              body: '<CHECK NETWORK FOR RESPONSE>' // Avoiding body as it is can be too big to stringify (ex rates)
            });
            this.debugLogService.flush({ appName, mode: 'HTTP RESPONSE' });
          } catch {}
        }
      })
    );
  }

  private shouldLogUrl(url: string): boolean {
    return (
      url.toLowerCase().includes(VIN_EP) ||
      url.toLowerCase().includes(RATES_EP) ||
      url.toLowerCase().includes(PROPOSALS_EP) ||
      url.toLowerCase().includes(BUNDLES_EP)
    );
  }
}
